import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import fmale from "../Components/Assets/fmale.png";
import nothing from "../Components/Assets/nothing.png";


const Community = () => {
  return (
    <>
      <Box sx={{ backgroundColor: "#0D0D0D",padding:"50px 0px" }}>
        <Box
          sx={{
            backgroundColor: "#091415",
            backgroundImage:`url(${nothing})`,
            borderTopRightRadius: { xs: "opx", md: "180px" },
            borderBottomRightRadius: { xs: "0px", md: "180px" },
            width: { xs: "98%", md: "90%" },
            padding: { xs: "0px", md: "50px 30px" },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "20px", md: "35px" },
              fontWeight: "700",
              lineHeight: "54px",
              letterSpacing: "0em",
              textAlign: "center",
              color: "#ffffff",
              margin: { xs: "0px", md: "10px 0px" },
            }}
          >
            Our community with User reviews
          </Typography>
          <Box
            sx={{
              backgroundColor: "#082D29",
              width: { xs: "80%", md: "80%" },
              marginLeft: { xs: "0px", md: "70px" },
              padding: "30px 0px",
              paddingLeft:"75px",
              alignItems: "center",
              borderRadius: { xs: "none", md: "180px" },

            }}
          >
          <Box sx={{display:"flex",gap:"50px",alignItems:"center",marginLeft:"20%",flexWrap: { xs: "wrap", md: "nowrap" },}}>
            <Box >
              <img src={fmale} alt="img"  />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: "500",
                  lineHeight: "32px",
                  letterSpacing: "0em",
                  textAlign: "left",
                  color: "rgba(128, 171, 158, 1)",
                  width: { xs: "100%", md: "60%" },
                }}
              >
                A Lorem Ipsum is simply dummy text of the printing and
                typesetting industry. Lorem Ipsum has been the industry's
                standard dummy text ever since the 1500s, when an unknown <br />
                <br />
                -Dake M. Chile, Business Owner of Bellie
              </Typography>
            </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Community;
